import Configuration from "./../config";
import { getConversationUrl as getIntercomConversationUrl } from "./intercom";
import { logError } from "./logging";
import { isProdOrigin } from "./util";

var agent = require("superagent");

export const SLACK_CHANNEL = Configuration.SLACK.channel;
const SLACK_WEB_HOOK_URL = Configuration.SLACK.webHookUrl;

export class SlackMessage {
  constructor(
    messageType, // SESSION WARNING
    pretext, // Need your attention ...
    title, // User didn't give us an access ...
    fallback,
    recommendation,
    icon, // :warning:
    color, // #ff0000
    actions
  ) {
    this.messageType = messageType + (isProdOrigin() ? "" : " (dev)");
    this.pretext = pretext;
    this.title = title;
    this.fallback = fallback;
    this.recommendation = recommendation;
    this.icon = icon;
    this.color = color;
    this.actions = actions;
  }
}

class SlackAction {
  constructor(type, text, url) {
    this.type = type;
    this.text = text;
    this.url = url;
  }
}

export class IntercomSlackAction extends SlackAction {
  constructor(userId, userName, userRole) {
    const message = userRole
      ? `Conversation with ${userName} (${userRole})`
      : `Conversation with ${userName}`;
    super("button", message, getIntercomConversationUrl(userId));
  }
}

export class SessionInAdminConsoleSlackAction extends SlackAction {
  constructor(lessonId) {
    const message = "Session in Admin Console";
    super("button", message, Configuration.ADMIN_CONSOLE_SESSIONS_LINK + lessonId);
  }
}

export function sendMessageToSlack(slackMessage) {
  var messageJSONStr =
    "payload= {" +
    '"username": "' +
    slackMessage.messageType +
    '",' +
    '"icon_emoji": "' +
    slackMessage.icon +
    '",' +
    '"channel": "' +
    SLACK_CHANNEL +
    '",' +
    '"attachments": [{' +
    '"fallback": "' +
    slackMessage.fallback +
    '",' +
    '"title": "' +
    slackMessage.title +
    '",' +
    '"color": "' +
    slackMessage.color +
    '",' +
    '"pretext": "' +
    slackMessage.pretext +
    '",' +
    (slackMessage.recommendation
      ? '"text": "Recommendation: ' + slackMessage.recommendation + '",'
      : "") +
    '"actions": ' +
    JSON.stringify(slackMessage.actions) +
    "}]" +
    "}";

  agent
    .post(SLACK_WEB_HOOK_URL)
    .send(messageJSONStr)
    .set("Content-Type", "application/x-www-form-urlencoded")
    .end(function (err, res) {
      if (err || !res.ok) {
        logError("was unable to send notification to slack", err);
      } else {
        // silently?
        //console.log(res.body);
      }
    });
}
